module.exports = __webpack_public_path__ + "img/5.972f00b6.svg";